export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
            关于香蕉漫画网
          </h2>

          <div className="prose prose-sm max-w-none">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              香蕉漫画网创建于2020年，是国内领先的<strong>漫画免费阅读</strong>平台。我们汇聚全网海量<strong>免费漫画</strong>资源，涵盖热血、恋爱、奇幻、悬疑、搞笑、科幻、修仙、校园、国漫等多个热门品类，致力于为广大漫迷提供最优质的<strong>免费看漫画</strong>体验。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              我们深知每一位漫画爱好者对内容品质和更新速度的追求。因此，香蕉漫画网坚持每日<strong>免费更新</strong>最新漫画章节，热门连载同步追更，日均更新超过200部作品。从经典完结到最新连载，<strong>免费漫画大全</strong>一应俱全，无需注册、无需付费，打开即可零成本畅享全本漫画。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              平台目前收录漫画超过五万部，拥有数百万活跃读者。我们承诺为每一位漫迷提供纯净、流畅、无干扰的<strong>免费在线漫画</strong>阅读环境。无论你是热血少年漫的死忠粉，还是恋爱甜宠的忠实读者，亦或是正在探索<strong>免费资源</strong>的新朋友，香蕉漫画网都是你<strong>无限阅读</strong>的最佳起点。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              未来，我们将持续扩充漫画资源库，优化阅读体验，让更多读者享受<strong>漫画免费看</strong>的乐趣。<strong>免费全集</strong>、<strong>零成本看漫画</strong>，就在香蕉漫画网。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
            <div className="p-4 rounded-xl bg-background-100">
              <div className="text-2xl font-heading font-bold text-primary-500">50,000+</div>
              <div className="text-xs text-foreground-600 mt-1">收录漫画</div>
            </div>
            <div className="p-4 rounded-xl bg-background-100">
              <div className="text-2xl font-heading font-bold text-accent-500">200+</div>
              <div className="text-xs text-foreground-600 mt-1">日均更新</div>
            </div>
            <div className="p-4 rounded-xl bg-background-100">
              <div className="text-2xl font-heading font-bold text-primary-500">300万+</div>
              <div className="text-xs text-foreground-600 mt-1">活跃读者</div>
            </div>
            <div className="p-4 rounded-xl bg-background-100">
              <div className="text-2xl font-heading font-bold text-accent-500">15+</div>
              <div className="text-xs text-foreground-600 mt-1">漫画品类</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}